<bk-auth-layout eyebrow="Admin console" [heading]="heading" [sub]="sub">
  @if (!successful) {
    <div class="bk-auth-step">
      @if (feedback) {
        <div class="bk-auth-note" data-tone="bad" role="alert" id="reset-error">
          <span class="bk-auth-dot" aria-hidden="true"></span>
          <div class="bk-auth-note__body">
            <p class="bk-auth-note__title">{{ feedback.title }}</p>
            <p class="bk-auth-note__quiet">{{ feedback.message }}</p>
          </div>
        </div>
      }

      <form
        class="bk-auth-form"
        [formGroup]="resetpasswordForm"
        (ngSubmit)="handleSubmit()"
        novalidate
        [attr.aria-busy]="isLoading"
      >
        <!-- email -->
        <div class="bk-field" [class.is-invalid]="showEmailError">
          <label class="bk-field__label" for="reset-email">Email address</label>
          <input
            id="reset-email"
            class="bk-field__input"
            type="email"
            inputmode="email"
            formControlName="email"
            placeholder="name@company.com"
            autocomplete="email"
            autocapitalize="none"
            autocorrect="off"
            spellcheck="false"
            [attr.aria-invalid]="showEmailError"
            [attr.aria-describedby]="showEmailError ? 'reset-email-error' : null"
          />
          @if (showEmailError) {
            <p class="bk-field__error" id="reset-email-error">
              <span class="bk-sym" aria-hidden="true">error</span>{{ emailErrorMessage }}
            </p>
          }
        </div>

        <!-- aria-disabled keeps focus on the button; handleSubmit ignores presses while sending -->
        <button
          type="submit"
          class="bk-btn bk-btn--primary bk-auth-cta"
          [attr.aria-disabled]="isLoading || null"
          [attr.aria-busy]="isLoading"
        >
          {{ isLoading ? "Sending link…" : "Send reset link" }}
        </button>
      </form>

      <p class="bk-auth-alt">
        <span>Remembered it? <a class="bk-auth-link" routerLink="/">Back to sign in</a></span>
      </p>
    </div>
  } @else {
    <div class="bk-auth-step">
      <ul class="bk-auth-facts">
        <li>
          <span class="bk-sym" aria-hidden="true">schedule</span>
          <span>The link works once, for 60 minutes.</span>
        </li>
        <li>
          <span class="bk-sym" aria-hidden="true">inbox</span>
          <span>Nothing after a few minutes? Check your spam or junk folder.</span>
        </li>
      </ul>

      @if (feedback) {
        <div class="bk-auth-note" data-tone="bad" role="alert">
          <span class="bk-auth-dot" aria-hidden="true"></span>
          <div class="bk-auth-note__body">
            <p class="bk-auth-note__title">{{ feedback.title }}</p>
            <p class="bk-auth-note__quiet">{{ feedback.message }}</p>
          </div>
        </div>
      }

      <div>
        <!-- aria-disabled, not disabled: focus stays here through the 60 s
             cooldown instead of falling to <body>. resend() ignores presses. -->
        <button
          type="button"
          class="bk-btn bk-btn--ghost bk-auth-wide"
          [attr.aria-disabled]="cooldown > 0 || isResending || null"
          [attr.aria-busy]="isResending"
          (click)="resend()"
        >
          <span class="bk-sym" aria-hidden="true">forward_to_inbox</span>
          @if (isResending) {
            Sending…
          } @else if (cooldown > 0) {
            Resend link in {{ cooldown }} s
          } @else {
            Resend link
          }
        </button>

        <div class="bk-auth-live" aria-live="polite">
          @if (resentAt) {
            <p class="bk-auth-inline" data-tone="ok">
              <span class="bk-auth-dot" aria-hidden="true"></span>
              Sent again at {{ resentTime }}. Use the newest email.
            </p>
          }
        </div>
      </div>

      <p class="bk-auth-alt">
        <button type="button" class="bk-auth-link" (click)="useDifferentEmail()">Use a different email</button>
        <a class="bk-auth-link" routerLink="/">Back to sign in</a>
      </p>
    </div>
  }
</bk-auth-layout>
